module.exports = __webpack_public_path__ + "static/img/zs.c998c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zs.png
// module id = i/CO
// module chunks = 1